import createTag from '../createTag';
import trimResultTransformer from '../trimResultTransformer';
import replaceResultTransformer from '../replaceResultTransformer';
var oneLineTrim = createTag(replaceResultTransformer(/(?:\n\s*)/g, ''), trimResultTransformer());
export default oneLineTrim;